import React, { useContext, useEffect, useState } from "react";
import { Box } from "rizzui/box";
import { Text } from "rizzui/typography";
import FormBox from "./fromBox";
import { Controller, useForm } from "react-hook-form";
import { Button } from "rizzui/button";
import cn from "../../../lib/utils/class-name";
import GoogleCalendar from "../../../assets/googleCalendar";
import { useMutation, useQuery } from "@tanstack/react-query";
import { AuthContext } from "../../../context/authContext";
import { baseUrl } from "../../account/login";
import axios from "axios";
import { useNavigate } from "react-router";
import { useNotifcication } from "../../../hooks/useNotification";
import AppointmentIcon from "../../../assets/appointments";
import { useModal } from "../../../hooks/useModal";
import SetAvailability from "../../../component/setAvailability";
import SetCallTime from "../../../component/setCallTime";
import { useSingleAvailability } from "../../../hooks/useCampaign";
import { inputClassName, labelClassName } from "./first";
import { Tooltip } from "rizzui/tooltip";
import CryptoJS from "crypto-js";
import CreateNumber from "../../../component/createNumber";
import Select from "react-select";
import { useColorStyle } from "../../../hooks/useColorStyle";
import { ThemeContext } from "../../../context/themeContext";
import { useUserPhones } from "../../../hooks/useProfileDetails";
import { useUserCalendar } from "../../../hooks/useCalendar";
import { Radio } from "rizzui/radio";
import ContactEnrichment from "../../../component/contactEnrichment";

export const projectFieldValidation = {
  required: {
    value: true,
    message: "Required",
  },
};

export default function Fourth({ data }) {
  const { page, setPage, setCurrentId, campaign, isEdit } = data;
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    control,
    reset,
    getValues,
    setValue,
  } = useForm();
  const [callTimeSet, setCallTimeSet] = useState(false);
  const [appointmentSet, setAppointmentSet] = useState(false);
  const [connecting, setConnecting] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const navigate = useNavigate();
  const { openNotification } = useNotifcication();
  const enable = () => setValue("enrichment", "enrich");
  const dont_enable = () => setValue("enrichment", "no_enrichment");

  const { theme } = useContext(ThemeContext);

  const { data: numbers, isLoading } = useUserPhones();
  const { data: calendars } = useUserCalendar();
  const phoneNumbers:
    | { label: string; value: string; key: string }[]
    | undefined = numbers?.data?.map((number) => {
    return {
      label: number.phone_number,
      value: number._id,
      key: number._id,
    };
  });
  const { campaignColorStyles: colorStyles } = useColorStyle(theme);

  const handleNext = handleSubmit((data) => {
    checkAvailability();
    //setDone(true);
  });

  const campaign_id = sessionStorage.getItem("campaign_id");
  const availability = campaign?.availabilityDetails;
  const { data: appointmentAvailability } = useSingleAvailability({
    id: campaign_id,
  });
  const { token } = useContext(AuthContext);
  const AuthStr = "Bearer ".concat(token);
  const { openModal, view, closeModal } = useModal();

  useEffect(() => {
    const callTime = sessionStorage.getItem("call_time");
    if (callTime === "true") {
      setCallTimeSet(true);
    }
  }, [closeModal]);

  useEffect(() => {
    setCallTimeSet(!!availability?.weeklyAvailability?.length);
  }, [availability]);

  useEffect(() => {
    setAppointmentSet(appointmentAvailability?.data?.length > 0);
  }, [appointmentAvailability]);

  /*   useEffect(() => {
    if (!campaign?.campaign_phone_numbers || !phoneNumbers) return;

    const currentValue = watch("phoneNumbers");
    const mappedPhones = campaign.campaign_phone_numbers
      .map((number: string) => phoneNumbers.find((num) => num.value === number))
      .filter(Boolean);

    const hasMismatch =
      mappedPhones.length !== currentValue?.length ||
      !mappedPhones.every(
        (item, idx) => item?.value === currentValue?.[idx]?.value
      );

    if (hasMismatch) {
      reset({
        ...getValues(),
        phoneNumbers: mappedPhones,
      });
    }
  }, [campaign?.campaign_phone_numbers, phoneNumbers]); */

  useEffect(() => {
    if (initialized || !campaign?.campaign_phone_numbers || !phoneNumbers)
      return;

    const mappedPhones = campaign.campaign_phone_numbers
      .map((number: string) => phoneNumbers.find((num) => num.value === number))
      .filter(Boolean);

    reset((prev) => ({
      ...prev,
      phoneNumbers: mappedPhones,
    }));

    setInitialized(true);
  }, [campaign?.campaign_phone_numbers, phoneNumbers, reset]);
  const key = process.env.REACT_APP_SECRET_KEY;

  const finishCampaignAvailability = async () => {
    const { phoneNumbers } = getValues();
    const phone_numbers = phoneNumbers?.map((number) => number?.value);
    return axios
      .post(
        `${baseUrl}/campaigns/${campaign_id}/phone_numbers`,
        {
          campaign_phone_numbers: phone_numbers,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((response) => {
        if (response?.status === 201) {
          const callTime = sessionStorage.getItem("call_time");
          if (callTime === "true" || callTimeSet) {
            const newpage = page + 1;
            const encryptedPage = CryptoJS.AES.encrypt(
              JSON.stringify(newpage),
              key!
            ).toString();
            sessionStorage.setItem("new_campaign_page", encryptedPage);
            setPage(page + 1);
            return Promise.resolve("Call time is set");
          } else {
            return Promise.reject(
              new Error("Set AI call time before proceeding")
            );
          }
        }
      })
      .catch((e) => {
        return Promise.reject(new Error(e.message));
      });
  };
  const {
    mutate: checkAvailability,
    isPending: callLoading,
    error: callError,
    data: response,
  } = useMutation({
    mutationFn: () => finishCampaignAvailability(),
    retry: 0,
  });

  const connectCalendar = (calendar: string) => {
    setConnecting(true);
    axios
      .post(
        `${baseUrl}/calendar/${calendar}/auth_url`,
        {},
        { headers: { Authorization: AuthStr } }
      )
      .then((response) => {
        if (response?.data?.success) {
          const { auth_url } = response?.data?.data;
          window.open(auth_url, "_blank");
          openNotification({
            status: "success",
            message: "Calendar Connected",
          });
          setConnecting(false);
        }
      })
      .catch((e) => {
        openNotification({
          status: "error",
          message: "Calendar Not Connected",
        });
        setConnecting(false);
        if (e?.response?.data?.statusCode === 401) navigate("/account/logout");
        return Promise.reject(
          new Error(e?.message ?? "Check your internet connection")
        );
      });
  };

  const calendarOptions = [{ label: "Google", value: "google" }];
  return (
    <FormBox
      title={"Call availability"}
      subtitle={"Set AI call time and your availability"}
      containerClass={
        "w-full text-secondary-dark font-switzer text-[12px] font-[400] leading-[15.84px] align-self-top self-top"
      }
      parentClass={"self-start md:w-[460px] mb-2"}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleNext();
        }}
        className="flex flex-col gap-[16px]"
        noValidate
      >
        <Box className="flex justify-between place-items-center h-[34px] my-[16px]">
          <div className="flex flex-row gap-[8px]">
            <AppointmentIcon className={"text-primary-dark size-[24px]"} />
            <div className="min-w-[170px]">
              <Text className="font-switzer text-[14px] text-primary-dark font-[400] leading-[18.84px]">
                {callTimeSet ? "Edit " : "Set "} AI call time
              </Text>
              <Text className="font-switzer text-[12px] text-[#758599] font-[400] leading-[15.84px]">
                Set when the AI should call customers
              </Text>
            </div>
          </div>
          <Button
            onClick={() =>
              openModal({
                view: <SetCallTime availability={availability} />,
              })
            }
            variant="text"
            disabled={connecting}
            className="px-[5px] !py-[6px] md:py-[0px] md:h-[26px] bg-inherit text-primary-dark font-[400] font-gilroyMedium, text-[12px] hover:bg-inherit border hover:text-primary-dark border-primary-dark"
          >
            {callTimeSet ? "Edit " : "Set "} Call Time
          </Button>
        </Box>

        <Controller
          control={control}
          name="phoneNumbers"
          rules={{
            required: {
              value: true,
              message: "Select at least one phone number",
            },
          }}
          render={({ field: { onChange, value, name } }) => (
            <div>
              <div className="mb-1.5 justify-between flex">
                <div className="flex flex-row gap-[5px] items-center">
                  <Text className={labelClassName}>Phone number*</Text>
                  {/* <Tooltip
                    rounded="sm"
                    content={
                      <Text className="w-[220px] text-center text-[13px]">
                        A knowledge base is a collection of resources that your
                        AI assistant can easily access for information.
                      </Text>
                    }
                    className="font-switzer text-[12px] font-[400] !w-[150px] rounded-[8px]"
                  >
                    <Button
                      className="!p-0 !bg-transparent !m-0 !h-fit cursor-text disabled:border-none disabled:cursor-text"
                      disabled
                    >
                      <BsFillInfoCircleFill size={12} className="mt-[1px]" />
                    </Button>
                  </Tooltip> */}
                </div>

                <Text
                  onClick={() =>
                    openModal({
                      view: <CreateNumber />,
                    })
                  }
                  className=" cursor-pointer underline font-switzer font-[500] text-[12px] leading-[15.84px] text-primary-dark"
                >
                  Add a new phone number
                </Text>
              </div>
              <Select
                options={[
                  {
                    label: "Add a new phone number",
                    value: "add_new_number",
                    key: "add_new_number",
                  },
                  ...(phoneNumbers || []),
                ]}
                isMulti
                className={cn("w-full")}
                isClearable
                placeholder=""
                isSearchable={false}
                isLoading={isLoading}
                styles={colorStyles}
                value={value}
                name={name}
                onChange={(selected) => {
                  if (
                    selected?.some(
                      (option) => option.value === "add_new_number"
                    )
                  ) {
                    openModal({
                      view: <CreateNumber />,
                    });
                    // Remove the "upload_new_file" option from the selected values
                    const filtered = selected.filter(
                      (option) => option.value !== "add_new_number"
                    );
                    onChange(filtered);
                  } else {
                    onChange(selected);
                  }
                }}
              />
              {errors.phoneNumbers?.message && (
                <p className="text-red text-[13px] mt-0.5 rizzui-textarea-error-text">
                  {"" + errors.phoneNumbers.message}
                </p>
              )}
            </div>
          )}
        />

        <Box className="flex justify-between place-items-center h-[34px] my-[16px]">
          <div className="flex flex-row gap-[8px]">
            <AppointmentIcon className={"text-primary-dark size-[24px]"} />
            <div className="min-w-[170px]">
              <Text className="font-switzer text-[14px] text-primary-dark font-[400] leading-[18.84px]">
                {appointmentSet ? "Adjust " : "Set "} your calendar availability
              </Text>
              <Text className="font-switzer text-[12px] text-[#758599] font-[400] leading-[15.84px]">
                Set this to easily book an appointment
              </Text>
            </div>
          </div>
          <Button
            onClick={() =>
              openModal({
                view: <SetAvailability page="campaign" id={campaign_id!} />,
              })
            }
            variant="text"
            disabled={connecting}
            className="px-[5px] !py-[6px] md:py-[0px] md:h-[26px] bg-inherit text-primary-dark font-[400] font-gilroyMedium, text-[12px] hover:bg-inherit border hover:text-primary-dark border-primary-dark"
          >
            {appointmentSet ? "Adjust " : "Set "} Availability
          </Button>
        </Box>

        {calendars?.length < 1 && (
          <Controller
            control={control}
            name="calendar"
            rules={{
              required: {
                value: false,
                message: "Required",
              },
            }}
            render={({ field: { onChange, value, name } }) => (
              <div className="flex flex-col gap-[8px]">
                <Text className={labelClassName}>Connect calendar</Text>
                <Select
                  options={calendarOptions}
                  className={cn()}
                  placeholder="Select a calendar..."
                  styles={colorStyles}
                  isSearchable={false}
                  value={value}
                  name={name}
                  onChange={onChange}
                />
                {errors.calendar?.message && (
                  <p className="text-red text-[13px] mt-0.5 rizzui-textarea-error-text">
                    {"" + errors.calendar.message}
                  </p>
                )}
              </div>
            )}
          />
        )}

        {calendars?.find(
          (calendar) => calendar?.calendar_name === "google"
        ) && (
          <Box className="flex justify-between place-items-center h-[34px] mb-[32px]">
            <div className="flex flex-row gap-[8px] w-[220px]">
              <GoogleCalendar className={""} />
              <div className="min-w-[170px]">
                <Text className="font-switzer text-[14px] text-primary-dark font-[400] leading-[18.84px]">
                  Google calendar
                </Text>
                <Text className="font-switzer text-[12px] text-[#758599] font-[400] leading-[15.84px]">
                  Connect to your google calendar
                </Text>
              </div>
            </div>
            <Button
              variant="text"
              isLoading={connecting}
              onClick={() => {}}
              className="w-[92px] h-[26px] bg-inherit text-primary-dark font-[400] font-gilroyMedium, text-[12px] leading-[14.56px] hover:bg-inherit border hover:text-primary-dark border-primary-dark"
            >
              Disconnect
            </Button>
          </Box>
        )}

        {calendars?.length < 1 && watch("calendar")?.value === "google" && (
          <Box className="flex justify-between place-items-center h-[34px]">
            <div className="flex flex-row gap-[8px] w-[220px]">
              <GoogleCalendar className={""} />
              <div className="min-w-[170px]">
                <Text className="font-switzer text-[14px] text-primary-dark font-[400] leading-[18.84px]">
                  Google calendar
                </Text>
                <Text className="font-switzer text-[12px] text-[#758599] font-[400] leading-[15.84px]">
                  Connect to your google calendar
                </Text>
              </div>
            </div>
            <Button
              variant="text"
              isLoading={connecting}
              onClick={() => connectCalendar("google")}
              className="w-[92px] h-[26px] bg-inherit text-primary-dark font-[400] font-gilroyMedium, text-[12px] leading-[14.56px] hover:bg-inherit border hover:text-primary-dark border-primary-dark"
            >
              Connect
            </Button>
          </Box>
        )}
        {/*         <div className="flex flex-col gap-[12px] -mt-[16px]">
          <div className="flex justify-between">
            <Text className={labelClassName}>Contact data enrichment</Text>{" "}
            <Text>Up to $0.05 per contact</Text>
          </div>
          <div className="flex flex-col gap-[12px]">
            <Radio
              label="Yes, proceed"
              value="enrich"
              size="sm"
              labelClassName={cn(
                labelClassName,
                "!text-primary-dark ml-[16px]"
              )}
              {...register("enrichment", {
                ...projectFieldValidation,
              })}
              onChange={(e) => {
                e.preventDefault();
                openModal({
                  view: (
                    <ContactEnrichment
                      enable={enable}
                      dont_enable={dont_enable}
                    />
                  ),
                });
              }}
            />

            <Radio
              label="No, don't"
              size="sm"
              value="no_enrichment"
              labelClassName={cn(
                labelClassName,
                "!text-primary-dark ml-[16px]"
              )}
              {...register("enrichment", {
                ...projectFieldValidation,
              })}
            />
          </div>
        </div> */}
        <div className="flex justify-between gap-[26px] mt-[32px]">
          <Button
            onClick={() => {
              setCurrentId(campaign_id);
              const newpage = page - 1;
              const encryptedPage = CryptoJS.AES.encrypt(
                JSON.stringify(newpage),
                key!
              ).toString();
              sessionStorage.setItem("new_campaign_page", encryptedPage);
              setPage(newpage);
            }}
            className="h-[40px] !bg-[#F2F2F2] dark:!bg-muted dark:!text-[#D9D9D9] w-[119px] !rounded-[4px] font-[500] font-switzer text-[12px] leading-[15.84px] text-[#191919]"
          >
            Go back
          </Button>
          <Button
            type="submit"
            isLoading={callLoading}
            className="h-[40px] !bg-btn w-[251px] rounded-[4px] font-[500] font-switzer text-[12px] leading-[15.84px] text-background"
          >
            Continue
          </Button>
        </div>
      </form>
      {callError && (
        <Text className="text-[red] font-switzer text-[12px] mt-2 font-[400]">
          {callError.message}
        </Text>
      )}
    </FormBox>
  );
}
